import React, { useState, useEffect } from "react";
import { Container, Row, Col, Stack, Badge, InputGroup, Table } from "react-bootstrap";
import { RequestService } from "../../../../HttpService/RequestService";
import Placeholder from 'react-bootstrap/Placeholder';
import { MdVisibility, MdDelete, MdGrid3X3, MdCircle, MdComment } from "react-icons/md";
import Swal from 'sweetalert2';
import Iframe from 'react-iframe';
import dateFormat from "dateformat";
import { loadModules } from "esri-loader";
import { FaDatabase, FaCalendar, FaFileDownload } from "react-icons/fa";
import { TODIS_DROPDOWN, TODIS_FILTER, TODIS_FORM_FIELD_GROUP } from "../../../../components/Forms";
import { TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_DATEPICKER } from "../../../../components/Buttons";
import { BsGeoAlt, BsGrid, BsGridFill, BsCloudSlashFill, BsCheck, BsPersonCircle, BsX, BsSortDown } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AuxiliaryService } from "../../../../HttpService/AuxiliaryService";
import 'sweetalert2/src/sweetalert2.scss'
import style from "../Requests.module.scss";
import "../../../DataCollection/style.css";
import { VscFiles, VscGlobe, VscOutput, VscDashboard, VscChevronRight, VscGithubAction, VscGraph, VscProject } from "react-icons/vsc";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';                       // core css
import 'primeicons/primeicons.css';                                 // icons
import { UrlServicesEUACQUIS } from "../../../../.config";
import { VscSymbolColor } from "react-icons/vsc";
import html2canvas from "html2canvas";
import jsPdf from "jspdf";
import downloadjs from 'downloadjs';
import { FaMapMarkedAlt } from "react-icons/fa";
import { TODIS_Visor_EUACQUIS } from "../../../../components/Modals/ModalVisorEUACQUIS";
import { Button } from 'primereact/button';
import moment from 'moment';
import { HttpService } from "../../../../HttpService/HttpService";
import Modal from 'react-bootstrap/Modal';

const ModalEuAcquisHistory = ({ show, onHide, data }) => (
    <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
            <Modal.Title>EU Acquis History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {Array.isArray(data) && data.length > 0 ? (
                <div style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Year</th>
                                <th>Regional Partner</th>
                                <th>Status</th>
                                <th>Remarks</th>
                                <th>Validated</th>
                                <th>Action Plans</th>
                                <th>Table Concordance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.euAcquisId}>
                                    <td>{row.year}</td>
                                    <td>{row.regionalPartner}</td>
                                    <td>{row.transpositionStatus}</td>
                                    <td>{row.remarks || '-'}</td>
                                    <td>{row.validated ? 'Yes' : 'No'}</td>
                                    <td>{row.actionPlans}</td>
                                    <td>
                                        {row.tableConcordance
                                            ? <a href={row.tableConcordance} target="_blank" rel="noopener noreferrer">View</a>
                                            : '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div>No data found.</div>
            )}
        </Modal.Body>
    </Modal>
);

const SectionEUAcquis = ({permissions}) => {

    const navigate = useNavigate();

    const [order, setOrder] = useState(false)
    const [filterR, setFilterR] = useState({ "Status": [], "Regional Partner": [], "Type of Act": [], "Sector": [], "CELEX number": [], "Years": null, "Regulatory Area": [], "Action Plans": [],"Search type Act":[] })
    const [filter, setFilter] = useState({})
    const [requests, setRequestsR] = useState([])
    const [requestsnew, setrequestsnew] = useState([])
    const [status, setStatus] = useState([])
    const [regulatoryArea, setRegulatoryArea] = useState([])
    const [allRegulatoryArea, setAllRegulatoryArea] = useState([])
    const [sector, setSector] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [euacquiType, setEUAcquiType] = useState([])
    const [actionPlans, setActionPlans] = useState([])
    const [regionals, setRegionals] = useState([])
    const [responseR, setResponse] = useState(false)
    const [tasksNotFound, setTasksNotFound] = useState(false)
    const [fileName, setFileName] = useState("Reports");
    const [arrayexcel, setarrayexcel] = useState();
    const [fullMap, setfullMap] = useState(false);
    const [urlGraphic, seturlGraphic] = useState("");
    const [table, settable] = useState(true);
    const [legis, setlegis] = useState("");
    const [showHistory, setShowHistory] = useState(false);
    const [historyData, setHistoryData] = useState([]);


    var intervalId = setInterval(function() {
        var currentTimeInSeconds = Math.floor(Date.now() / 1000);
    
        if (currentTimeInSeconds % 2 === 0 && document.activeElement === document.getElementById('euacquis')) {
            localStorage.setItem('lastInteractionTime', moment().toISOString());
            setTimeout(function(){ window.focus(); }, 0);
        }
    }, 20000);

    var eventListener = window.addEventListener('blur', function() {
        var currentTimeInSeconds = Math.floor(Date.now() / 1000);
    
        if (currentTimeInSeconds % 2 === 0 && document.activeElement === document.getElementById('euacquis')) {
            localStorage.setItem('lastInteractionTime', moment().toISOString());
            setTimeout(function(){ window.focus(); }, 0);
        }
        window.removeEventListener('blur', eventListener);
    });

    const legislation = (valor)  => {

        setlegis(valor);

    }
    const imprimirDashboard = async () => {
        //var iframes = document.querySelector("iframe"); //te da los Iframes de la pagina
        var iframes = document.getElementById("euacquis");
        var iframeDocument = iframes.contentWindow.document;
        var contenido = iframeDocument.body;
        //contenido.querySelectorAll(".header-panel").forEach(e => e.remove());

        const canvas = await html2canvas(contenido);
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, 'download.png', 'image/png');
    };
    const expanding = (filter) => {

        const loadingSwal = Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            //showCancelButton: true,
            //cancelButtonText: 'Close',
            didOpen: () => {
                Swal.showLoading();
            }
        });


        var filterDashboard = "";
        var variables = "";
        var dashboard = "";

        if (filter.filter.regionalPartner) {
            if (filter.filter.sector == undefined) {

                dashboard = "BySector";
                if (filter.filter.fromDate) {
                    filterDashboard += "year=" + filter.filter.fromDate;
                }
                else {
                    filterDashboard += "year=";
                }
                if (filter.filter.regulatoryArea) {
                    variables = "";
                    filter.filter.regulatoryArea.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ra=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.regionalPartner) {
                    variables = "";
                    filter.filter.regionalPartner.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&rp=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.typeAct) {
                    variables = "";
                    filter.filter.typeAct.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ta=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.actionplans) {

                    variables = "";
                    filter.filter.actionplans.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&action=" + variables.substring(0, variables.length - 1);

                }
                if (filter.filter.celexNum) {
                    filterDashboard += "&celex" + filter.filter.celexNum;
                }

            }
            else if (filter.filter.regulatoryArea == undefined) {
                dashboard = "ByRegulatory";

                if (filter.filter.fromDate) {
                    filterDashboard += "year=" + filter.filter.fromDate;
                }
                else {
                    filterDashboard += "year=";
                }
                if (filter.filter.sector) {
                    filterDashboard += "&sector=" + filter.filter.sector[0].slice(1, -1);
                }
                if (filter.filter.regulatoryArea) {
                    variables = "";
                    filter.filter.regulatoryArea.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ra=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.regionalPartner) {
                    variables = "";
                    filter.filter.regionalPartner.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&rp=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.actionplans) {
                    variables = "";
                    filter.filter.actionplans.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&action=" + variables.substring(0, variables.length - 1);

                }
                if (filter.filter.celexNum) {
                    filterDashboard += "&celex" + filter.filter.celexNum;
                }

            }
            else if (filter.filter.typeAct == undefined) {
                dashboard = "ByTypeofAct";
                if (filter.filter.fromDate) {
                    filterDashboard += "year=" + filter.filter.fromDate;
                }
                else {
                    filterDashboard += "year=";
                }
                if (filter.filter.sector) {
                    filterDashboard += "&sector=" + filter.filter.sector[0].slice(1, -1);
                }
                if (filter.filter.regulatoryArea) {
                    variables = "";
                    filter.filter.regulatoryArea.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ra=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.regionalPartner) {
                    variables = "";
                    filter.filter.regionalPartner.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&rp=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.typeAct) {
                    variables = "";
                    filter.filter.typeAct.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ta=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.actionplans) {

                    variables = "";
                    filter.filter.actionplans.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&action=" + variables.substring(0, variables.length - 1);

                }
                if (filter.filter.celexNum) {
                    filterDashboard += "&celex" + filter.filter.celexNum;
                }
            }
            else {
                dashboard = "NoBarchart";
                if (filter.filter.fromDate) {
                    filterDashboard += "year=" + filter.filter.fromDate;
                }
                else {
                    filterDashboard += "year=";
                }
                if (filter.filter.sector) {
                    filterDashboard += "&sector=" + filter.filter.sector[0].slice(1, -1);
                }
                if (filter.filter.regulatoryArea) {
                    variables = "";
                    filter.filter.regulatoryArea.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ra=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.regionalPartner) {
                    variables = "";
                    filter.filter.regionalPartner.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&rp=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.typeAct) {
                    variables = "";
                    filter.filter.typeAct.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&ta=" + variables.substring(0, variables.length - 1);
                }
                if (filter.filter.actionplans) {

                    variables = "";
                    filter.filter.actionplans.map(items => {
                        variables += items.slice(1, -1) + ",";
                    })
                    filterDashboard += "&action=" + variables.substring(0, variables.length - 1);

                }
                if (filter.filter.celexNum) {
                    filterDashboard += "&celex" + filter.filter.celexNum;
                }
            }

        }
        else {
            dashboard = "ByRP";
            if (filter.filter.fromDate) {
                filterDashboard += "year=" + filter.filter.fromDate;
            }
            else {
                filterDashboard += "year=";
            }
            if (filter.filter.sector) {
                filterDashboard += "&sector=" + filter.filter.sector[0].slice(1, -1);
            }
            if (filter.filter.regulatoryArea) {
                variables = "";
                filter.filter.regulatoryArea.map(items => {
                    variables += items.slice(1, -1) + ",";
                })
                filterDashboard += "&ra=" + variables.substring(0, variables.length - 1);
            }
            if (filter.filter.typeAct) {
                variables = "";
                filter.filter.typeAct.map(items => {
                    variables += items.slice(1, -1) + ",";
                })
                filterDashboard += "&ta=" + variables.substring(0, variables.length - 1);
            }
            if (filter.filter.actionplans) {

                variables = "";
                filter.filter.actionplans.map(items => {
                    variables += items.slice(1, -1) + ",";
                })
                filterDashboard += "&action=" + variables.substring(0, variables.length - 1);

            }
            if (filter.filter.celexNum) {
                filterDashboard += "&celex" + filter.filter.celexNum;
            }

        }



        seturlGraphic(UrlServicesEUACQUIS[dashboard] + "#" + filterDashboard);
        if (!fullMap) { setfullMap(true) }




        Swal.close();
    }
    const ExportCSV = () => {
        // Mostrar Swal de carga
        const loadingSwal = Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            //showCancelButton: true,
            //cancelButtonText: 'Close',
            didOpen: () => {
                Swal.showLoading();
            }
        });

        let euacquis = []

        for (var i = 0; i < arrayexcel.length; i++) {
            euacquis.push({
                "Sector": arrayexcel[i].sector
                , "Regulatory Area": arrayexcel[i].regulatory_area
                , "Type of act": arrayexcel[i].type
                , "Celex number": arrayexcel[i].celex_number
                , "Legal act": arrayexcel[i].legislation
                , "Regional Partner": arrayexcel[i].regional_partner
                , "Transposition Status": arrayexcel[i].transposition_status
                , "Remark": arrayexcel[i].remarks
                , "Table of concordance": arrayexcel[i].table_concordance
            });
        };
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const ws = XLSX.utils.json_to_sheet(euacquis);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        
        Swal.close();
    }

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const statusClass = (status) => {
        if (status == "Not transposed")
            return "#ff0000";//rojo
        if (status == "Unknown")
            return "#c2c2c2"; //gris
        if (status == "Partially transposed")
            return "#ffff00" //amarrillo
        if (status == "Transposed")
            return "#4ce600" //verde
    }

    const getDataSelect = async () => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/euacquis,regionalpartner,transpositionstatus,regulatoryarea,euacquitype,actionplans").getAuxiliaries();

            auxiliaries.map(item => {
                if (item.txtNameTable == "euacquis")
                    setSector(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "regionalpartner") {
                    var d = item.auxtableDetailsDTOList.sort((a, b) => a.txtDescription.localeCompare(b.txtDescription));
                    setRegionals(d)
                }
                if (item.txtNameTable == "transpositionstatus")
                    setStatus(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "regulatoryarea")
                    setAllRegulatoryArea(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "euacquitype")
                    setEUAcquiType(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "actionplans")
                    setActionPlans(item.auxtableDetailsDTOList)
            })
        } catch (error) {
            console.log("error listing selects", error);
        }
    }
    const buildRequest = (request) => {

        const groupByCategory = groupBy(request, 'sector');

        Object.keys(groupByCategory).forEach((key) => {

            groupByCategory[key] = (groupBy(groupByCategory[key], 'regulatory_area'));

        });
        //console.log(groupByCategory)
        setRequestsR(groupByCategory);
    }

    const groupBy = (xs, key) => {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    const getRequests = async (filter) => {
        try {
            loadModules(["esri/layers/FeatureLayer", "esri/rest/support/Query"], {
                css: true
            }).then(([FeatureLayer, Query]) => {
                var filterquery = "1=1";
                var result = [];
                var layerElementDefault = new FeatureLayer({
                    url: UrlServicesEUACQUIS["ServicesMapServer"] + "0/query",
                });
                if (filter != null) {
                    settable(true);
                    if (filter.regionalPartner) {
                        filterquery += " AND regional_partner_id in (" + filter.regionalPartner + ")";
                        settable(false);
                    }
                    if (filter.sector) {
                        filterquery += " AND sector_id in (" + filter.sector + ")";
                    }
                    if (filter.regulatoryArea) {
                        filterquery += " AND regulatory_area_id in (" + filter.regulatoryArea + ")"
                    }
                    if (filter.typeAct) {
                        filterquery += " AND type_id in (" + filter.typeAct + ")"
                    }
                    if (filter.actionplans) {
                        filterquery += " AND action_plans_id in (" + filter.actionplans + ")"
                    }
                    if (filter.status) {
                        filterquery += " AND transposition_status_id in (" + filter.status + ")";
                    }
                    if (filter.celexNum) {
                        filterquery += "AND celex_number in (" + filter.celexNum + ")";
                    }
                    
                    if (filter.search) {                       
                        var arraydatos = filter.search;
                        var datos ="";                      
                        for (let i = 0; i < arraydatos.length; i++) {
                            if(i==0){
                                datos = arraydatos[i].replace(/'/g, '');
                                filterquery += " AND legislation like '%"+datos+"%' ";
                            }
                            else
                            {
                                datos = arraydatos[i].replace(/'/g, '');
                                filterquery += " OR legislation like '%"+datos+"%' ";
                            }
                            
                        }                                                
                    }
                    if (filter.fromDate) {
                        if (filter.toDate) {
                            filterquery += " AND year >= " + filter.fromDate + " AND year <= " + filter.toDate + "";
                        } else {
                            filterquery += " AND year = " + filter.fromDate + "";
                        }
                    }
                }                
                const query = new Query();
                query.where = filterquery;
                //query.outSpatialReference = { wkid: 102100 };
                query.returnGeometry = false;
                query.outFields = ["*"];
                layerElementDefault.queryFeatures(query).then(function (results) {

                    if (results.features.length > 0) {
                        for (var i = 0; i < results.features.length; i++) {
                            result.push(results.features[i].attributes)

                        }
                        console.log(result)
                        setarrayexcel(result);
                        buildRequest(result);
                        setrequestsnew(result);
                    }
                    else {
                        setarrayexcel([]);
                        buildRequest([])
                        setrequestsnew([]);
                    }
                    setResponse(true)
                });

            });
        } catch (error) {
            console.log("error listing EU Acquis", error);
            setTasksNotFound(true);
        }
    }

    const handleSelectR = (value, text, name, id) => {
        if (!filterR[name].some(item => item.name == text)) {
            setFilterR(prevState => {
                const newValue = { ...prevState };
                newValue[name] = [...newValue[name], { id: value, name: text }]
                return newValue
            })
            setFilter(prevState => {
                const newValue = { ...prevState };
                if (newValue[id] == undefined) {
                    newValue[id] = ["'" + value + "'"]
                } else {
                    if (!newValue[id].some(item => item == "'" + value + "'")) {
                        newValue[id].push("'" + value + "'")
                    }
                }
                return newValue
            })

        } else {
            Toast.fire({
                icon: 'warning',
                title: "Filter by " + name + " <b>" + text + "</b> is already applied"
            })
        }
    }

    const searchRegulatoryArea = (value, text, name, id) => {
        if (name == "Sector" && filterR[name].length != 0) {
            Toast.fire({
                icon: 'warning',
                title: "Filter by <b>" + name + "</b> is already applied"
            })
            return false;
        }

        handleSelectR(value, text, name, id);

        let filter = []

        filter = allRegulatoryArea.filter(item => item.countryCode == value)
        setRegulatoryArea(filter)
    }

    const handleDate = (value, name) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = value;
            return newValue
        })
        const dateRange = value.split(' ~ ')
        setFilter(prevState => {
            const newValue = { ...prevState };
            newValue["fromDate"] = dateRange[0];
            if (dateRange[1]) {
                newValue["toDate"] = dateRange[1];
            } else {
                delete newValue["toDate"]
            }
            return newValue
        })
    }

    const removeFilterR = (name, id, value) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = newValue[name].filter(item => item.id != value)
            console.log("filter Request", newValue)
            return newValue
        })

        setFilter(prevState => {
            const newValue = { ...prevState };
            newValue[id] = newValue[id].filter(item => item != ("'" + value + "'"))
            if (newValue[id].length == 0)
                delete newValue[id]
            return newValue
        })
    }

    const removeFilterSector = (name, id, value) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue["Regulatory Area"] = []
            return newValue
        })

        setFilter(prevState => {
            const newValue = { ...prevState };
            if (newValue["regulatoryArea"])
                delete newValue["regulatoryArea"]
            return newValue
        })

        setRegulatoryArea([])
        removeFilterR(name, id, value);
    }

    const removeFilterDate = (name) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = null
            return newValue
        })

        setFilter(prevState => {
            const newValue = { ...prevState };
            delete newValue["fromDate"]
            delete newValue["toDate"]
            return newValue
        })
    }

    const filterCELEX = (value, e, name, id) => {
        handleSelectR(value, value, name, id)
        e.target.value = "";
    }
    const filterDescription = (value, e, name, id) => {
        handleSelectR(value, value, name, id)
        e.target.value = "";
    }
    useEffect(() => {
        (async () => {
            setResponse(false)
            await getRequests(filter);
            if (fullMap == true) {
                expanding({ filter })
            }

        })();
    }, [filter]);

    useEffect(() => {
        (async () => {
            await getDataSelect();
        })();
    }, []);

    const lockTemplate = (rowData, options) => {
        //const icon = options.frozenRow ? 'pi pi-lock' : 'pi pi-lock-open';
        // const disabled = options.frozenRow ? false : lockedCustomers.length >= 2;

        return <TODIS_BTN_SECUNDARY variant="primary" icon={VscFiles} sizeIcon="20" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} onclick={() => window.open(rowData.table_concordance, "_blank")} />;
    };
    const VisorButton = (rowData, options) => {
        //const icon = options.frozenRow ? 'pi pi-lock' : 'pi pi-lock-open';
        // const disabled = options.frozenRow ? false : lockedCustomers.length >= 2;

        return <TODIS_BTN_SECUNDARY variant="primary" icon={FaMapMarkedAlt} sizeIcon="20" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} onclick={() => { setShowModal(true); legislation(rowData.legislation); }} />;
    };
    const EyeButton = (rowData, options) => {
        // Botón de ojo para ver detalles: muestra historial en modal
        return (
            <TODIS_BTN_SECUNDARY
                variant="primary"
                icon={MdVisibility}
                sizeIcon="20"
                style={{ fontSize: "12px", padding: "0.7rem 1rem" }}
                onclick={async () => {
                    const payload = { celexnumber: rowData.celex_number, sector: rowData.sector };
                    try {
                        // Usa SIEMPRE el endpoint 'api/euAcquisDetails'
                        const res = await new HttpService('euAcquisDetails').post(payload);
                        // El backend devuelve los datos en res.data.data.data o res.data.data
                        let data = [];
                        if (res?.data?.data?.data && Array.isArray(res.data.data.data)) {
                            data = res.data.data.data;
                        } else if (res?.data?.data && Array.isArray(res.data.data)) {
                            data = res.data.data;
                        }
                        setHistoryData(data);
                        setShowHistory(true);
                    } catch (err) {
                        setHistoryData([]);
                        setShowHistory(true);
                        console.error('Error enviando datos:', err);
                    }
                }}
            />
        );
    };
    const legislacion = (rowData, options) => {
        //const icon = options.frozenRow ? 'pi pi-lock' : 'pi pi-lock-open';
        // const disabled = options.frozenRow ? false : lockedCustomers.length >= 2;

        return <>
            {rowData.legislation}
            <br />
            <span><BsGeoAlt size="18" color="#004494" /> {rowData.regional_partner}</span>&nbsp;&nbsp;
            <span style={{ textTransform: "capitalize" }}><MdCircle size="18" className="me-1" color={statusClass(rowData.transposition_status)} /> {rowData.transposition_status}</span>;
        </>


    };
    // const mapbutton = (rowData, options) => {
    //     //const icon = options.frozenRow ? 'pi pi-lock' : 'pi pi-lock-open';
    //    // const disabled = options.frozenRow ? false : lockedCustomers.length >= 2;

    //     return <TODIS_BTN_SECUNDARY variant="primary" icon={FaMapMarkedAlt} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => {setShowModal(true); legislation(rowData.legislation); }} />;
    // };
    return (


        <Container fluid className="col-sm-12">

            <Row style={{ height: "100%" }}>

                <Col style={{ paddingRight: 0 }} sm={fullMap ? 6 : 12}>
                    <Container fluid className="todis-form-wrapper p-4" style={{ height: '98%' }} >
                        <Row className="todis-form-action-panel pb-3">

                            <Col lg={12} className="pt-2">
                                <Row >
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <h5 className="todis-header">EU ACQUIS</h5>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DROPDOWN title="Regional Partner" handleSelect={(e, evt) => handleSelectR(e, evt.target.text, "Regional Partner", "regionalPartner")} response={responseR} items={regionals} type={"country_code"} icon={BsGeoAlt} />
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DROPDOWN title="Sector" handleSelect={(e, evt) => searchRegulatoryArea(e, evt.target.text, "Sector", "sector")} response={responseR} items={sector} icon={BsGrid} />
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DROPDOWN title="Reg. Area" handleSelect={(e, evt) => handleSelectR(e, evt.target.text, "Regulatory Area", "regulatoryArea")} response={responseR} items={regulatoryArea} icon={BsGridFill} />
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DROPDOWN title="Type of Act" handleSelect={(e, evt) => handleSelectR(e, evt.target.text, "Type of Act", "typeAct")} response={responseR} items={euacquiType} icon={VscOutput} />
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DROPDOWN title="Action Plans" handleSelect={(e, evt) => handleSelectR(e, evt.target.text, "Action Plans", "actionplans")} response={responseR} items={actionPlans} icon={VscGithubAction} />
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DROPDOWN title="Status" handleSelect={(e, evt) => handleSelectR(e, evt.target.text, "Status", "status")} response={responseR} items={status} icon={VscProject} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12} className="pt-2">
                                <Row >
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_FILTER placeholder="CELEX number" onFilter={(e) => { if (e.key == "Enter") filterCELEX(e.target.value, e, "CELEX number", "celexNum") }} />
                                    </Col>
                                    <Col lg={1} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Years")} onlyYearPicker={true} placeholder="Years" />
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto', paddingInline: "7px" }}>
                                        <TODIS_FILTER placeholder="Search Legal act" onFilter={(e) => { if (e.key == "Enter") filterDescription(e.target.value, e, "Search type Act", "search") }} />
                                    </Col>
                                    <Col lg={1} style={{ width: 'auto' }}>
                                        <TODIS_BTN_PRIMARY variant="primary" classes="fw-bolder" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} icon={FaFileDownload} onclick={() => ExportCSV()} />
                                    </Col>
                                    <Col lg={1} style={{ width: 'auto' }}>
                                        <TODIS_BTN_PRIMARY variant="primary" classes="fw-bolder" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} icon={VscGraph} onclick={() => expanding({ filter })} />
                                    </Col>
                                </Row>
                            </Col>
                            {<Col lg={12} className="ps-4 pt-3" style={{ maxHeight: "50px", overflowY: "auto" }}>
                                <Row className="float-start">
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Regional Partner:
                                            {
                                                filterR["Regional Partner"].length != 0 ?
                                                    filterR["Regional Partner"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Regional Partner", "regionalPartner", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Regional Partner</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Sector:
                                            {
                                                filterR["Sector"].length != 0 ?
                                                    filterR["Sector"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterSector("Sector", "sector", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Sector</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Reg. Area:
                                            {
                                                filterR["Regulatory Area"].length != 0 ?
                                                    filterR["Regulatory Area"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Regulatory Area", "regulatoryArea", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Reg. Area</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Type to Act.:
                                            {
                                                filterR["Type of Act"].length != 0 ?
                                                    filterR["Type of Act"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Type of Act", "typeAct", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Type to Act.</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Action Plans.:
                                            {
                                                filterR["Action Plans"].length != 0 ?
                                                    filterR["Action Plans"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Action Plans", "actionplans", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" />All Action Plans</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Status:
                                            {
                                                filterR["Status"].length != 0 ?
                                                    filterR["Status"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Status", "status", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Status</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            CELEX:
                                            {
                                                filterR["CELEX number"].length != 0 ?
                                                    filterR["CELEX number"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("CELEX number", "celexNum", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All CELEX</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Years:
                                            {
                                                filterR["Years"] != null ?
                                                    <Badge className={style.bgFilter}><span className={style.cursorPointer} onClick={() => removeFilterDate("Years")}><BsX fontSize={16} color="#3e84b8" /></span> {filterR["Years"]}</Badge>
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Years</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                        <h6 style={{ fondSize: "0.8rem" }}>
                                            Search:
                                            {
                                                filterR["Search type Act"].length != 0 ?
                                                    filterR["Search type Act"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Search type Act", "search", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" />Search type Act</Badge>
                                            }
                                        </h6>
                                    </Col>
                                </Row>
                            </Col>}
                        </Row>

                        <Row className="todis-form-action-panel pb-3" style={{ overflow: "auto", maxHeight: "calc(87vh - 275px)" }}>

                            {
                                !tasksNotFound && responseR ?

                                    table ?
                                        <DataTable value={requestsnew} loading={false} >
                                            <Column field="sector" header="Sector" style={{ width: '10%' }}></Column>
                                            <Column field="regulatory_area" header="Regulatory Area" style={{ width: '10%' }}></Column>
                                            <Column field="type" header="Type of act" style={{ width: '10%' }}></Column>
                                            <Column field="celex_number" header="Celex number" style={{ width: '10%' }}></Column>
                                            <Column header="Legal act" style={{ width: '60%' }} body={legislacion}></Column>
                                            <Column style={{ flex: '0 0 4rem' }} body={EyeButton}></Column>
                                            <Column style={{ flex: '0 0 4rem' }} body={lockTemplate}></Column>
                                            <Column style={{ flex: '0 0 4rem' }} body={VisorButton}></Column>
                                            {/* <Column style={{ flex: '0 0 4rem' }} body={mapbutton}></Column> */}
                                        </DataTable>
                                        :
                                        (requestsnew.map((request) => (

                                            <Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} style={{ fontSize: "15px" }} key={request.eu_acquis_id}>
                                                <Container className="ms-2" style={{ maxWidth: "none" }}>
                                                    <Row>
                                                        <Col lg={11}>
                                                            <h4 className="fw-bold" style={{ fontSize: "21px" }}> {request.sector}  - {request.regulatory_area}</h4>
                                                            <Row>
                                                                <Col lg={1} style={{ paddingInline: "7px", width: "auto" }} >
                                                                    <span><BsGeoAlt size="18" color="#004494" /> {request.regional_partner}</span>
                                                                </Col>
                                                                <Col lg={3} style={{ paddingInline: "7px", width: "auto" }}>
                                                                    <span style={{ textTransform: "capitalize" }}><MdCircle size="18" className="me-1" color={statusClass(request.transposition_status)} />  {request.transposition_status}</span>
                                                                </Col>
                                                                <Col lg={12} style={{ paddingInline: "7px", width: "auto" }}>
                                                                    <span><VscGlobe size="18" className="me-1" color="#004494" /> {request.legislation}</span>
                                                                </Col>
                                                                <Col lg={12} style={{ paddingInline: "7px", width: "auto" }}>
                                                                    <span style={{ textTransform: "capitalize" }}><VscOutput size="18" className="me-1" color="#004494" /> {request.remarks}</span>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col lg={1} className="p-0" style={{ alignSelf: "center" }}>
                                                            <Row style={{ float: "right" }}>
                                                            <Col lg={12}>
                                                                <TODIS_BTN_SECUNDARY 
                                                                    variant="primary" 
                                                                    icon={VscFiles} 
                                                                    sizeIcon="20" 
                                                                    style={{ fontSize: "12px", padding: "0.7rem 1rem" }} 
                                                                    onclick={() => {
                                                                        // Mostrar Swal fijo
                                                                        Swal.fire({
                                                                            title: 'Processing...',
                                                                            text: 'Please wait while we process your request.',
                                                                            allowOutsideClick: false,
                                                                            //showCancelButton: true,
                                                                            //cancelButtonText: 'Close',
                                                                            didOpen: () => {
                                                                                Swal.showLoading();
                                                                            }
                                                                        });

                                                                        // Abrir la nueva ventana
                                                                        window.open(request.table_concordance, "_blank");

                                                                        // Cerrar Swal fijo
                                                                        Swal.close();
                                                                    }} 
                                                                />
                                                                </Col>

                                                                <Col lg={12}>
                                                                    <TODIS_BTN_SECUNDARY variant="primary" icon={FaMapMarkedAlt} sizeIcon="20" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} onclick={() => { 
                                                                        // Mostrar Swal fijo
                                                                        Swal.fire({
                                                                            title: 'Processing...',
                                                                            text: 'Please wait while we process your request.',
                                                                            allowOutsideClick: false,
                                                                            //showCancelButton: true,
                                                                            //cancelButtonText: 'Close',
                                                                            didOpen: () => {
                                                                                Swal.showLoading();
                                                                            }
                                                                        });
                                                                        setShowModal(true); 
                                                                        legislation(request.legislation); 
                                                                        Swal.close();
                                                                        }} />
                                                                </Col>
                                                                <Col lg={12}>
                                                                    <TODIS_BTN_SECUNDARY
                                                                        variant="primary"
                                                                        icon={MdVisibility}
                                                                        sizeIcon="20"
                                                                        style={{ fontSize: "12px", padding: "0.7rem 1rem" }}
                                                                        onclick={async () => {
                                                                            const payload = { celexnumber: request.celex_number, sector: request.sector };
                                                                            try {
                                                                                // Usa SIEMPRE el endpoint 'api/euAcquisDetails'
                                                                                const res = await new HttpService('api/euAcquisDetails').post(payload);
                                                                                let data = [];
                                                                                if (res?.data?.data?.data && Array.isArray(res.data.data.data)) {
                                                                                    data = res.data.data.data;
                                                                                } else if (res?.data?.data && Array.isArray(res.data.data)) {
                                                                                    data = res.data.data;
                                                                                }
                                                                                setHistoryData(data);
                                                                                setShowHistory(true);
                                                                            } catch (err) {
                                                                                setHistoryData([]);
                                                                                setShowHistory(true);
                                                                                console.error('Error enviando datos:', err);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>
                                        ))) : tasksNotFound ?
                                        <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                            <BsCloudSlashFill fontSize={100} color="#000000" />
                                            <h3 className="">Request Not found </h3>
                                        </div></div> :

                                        // loading requests
                                        ([...Array(7)].map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                            <Row>
                                                <Col lg={10}>
                                                    <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                                    <Row>
                                                        <Col lg={1} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col lg={2} className="p-0">
                                                    <Row>
                                                        <Col lg={6}>
                                                            <Placeholder.Button variant="light" xs={12} size="md" />
                                                        </Col>
                                                        <Col lg={6}>
                                                            <Placeholder.Button variant="light" xs={12} size="md" />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container></Col>)))
                            }
                        </Row>
                    </Container>

                </Col>
                {fullMap &&
                    <>

                        <Col style={{ padding: 0, width: '1.333333%', flex: '0 0 auto' }}><div style={{ paddingTop: "40vh", paddingLeft: "4px" }}><div style={{ display: "flex", alignItems: "center", borderRadius: "15px 0px 0px 15px", backgroundColor: "#004494", height: "100px" }} onClick={() => setfullMap(false)}><VscChevronRight size="23" color="white" /></div><div style={{ display: "flex", alignItems: "center", borderRadius: "15px 0px 0px 15px", backgroundColor: "#004494", height: "100px" }} onClick={imprimirDashboard}><VscSymbolColor size="23" color="white" /></div></div></Col>

                        <Col style={{ paddingLeft: 0, width: '48.333333%', flex: '0 0 auto', height: "98%" }} >

                            <Iframe url={urlGraphic}
                                width="100%"
                                height="100%"
                                id="euacquis"
                                name="euacquis"
                                display="block"
                                position="relative" />

                        </Col>
                    </>

                }
            </Row>
            {showModal && <TODIS_Visor_EUACQUIS title={"Map"} dataDashboard={legis} show={showModal} visor={"EUACQUIS"} onHide={() => setShowModal(false)} />}
            {showHistory && (
                <ModalEuAcquisHistory
                    show={showHistory}
                    onHide={() => setShowHistory(false)}
                    data={historyData}
                />
            )}
        </Container>


    );
}

export default SectionEUAcquis;